(function () {
    'use strict';

    angular
        .module('app.stockHistories')
        .controller('StockHistoriesEditController', EditController);

    EditController.$inject = ['$location', '$stateParams', 'StockHistoriesService'];

    function EditController($location, $stateParams, Service) {
        /* jshint validthis:true */
        var vm = this;

        vm.loading = true;
        vm.title = '';

        Service.get($stateParams.StockHistoryId).then(function (data) {
            vm.entity = data;
            vm.loading = false;
        });

        vm.fields = Service.getFields();

        vm.edit = function () {
            if (vm.form.$valid) {
                vm.loading = true;
                Service.edit(vm.entity).then(function () {
                    vm.loading = false;
                    $location.path('/stockHistories/detail/' + vm.entity.Id);
                });
            }
        };
    }
})();